module.exports = "https://static.wagwalking.com/_next/static/images/maxbone-5-3b4367bdd40da31831f666fbb711a4ca.png";